import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Injector,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';
@Component({
  selector: 'app-dc-input-number-percent',
  templateUrl: './dc-input-number-percent.component.html',
  styleUrls: ['./dc-input-number-percent.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DcInputNumberPercentComponent,
      multi: true,
    },
  ],
})
export class DcInputNumberPercentComponent extends ControlValueAccessorConnector {
  @Input() placeholder: string;
  @Input() label: string;
  @Input() id: string;
  @Input() helpText?: string;
  @Input() field: any;
  @Input() type: 'text' | 'number'; // if using a mask, you need to use text
  @Input() defaultUnit: 'abs' | 'pct';
  @Input() lockDefault: boolean = false;

  @Input() mask: string; // ngx-mask property - see docs for options
  @Input() thousandSeparator: string; // ngx-mask property - see docs for options
  @Input() dropSpecialCharacters: string; // ngx-mask property
  @Input() allowNegativeNumbers: string; // ngx-mask property
  @Input() showTicksIfValid: boolean; // off by default

  @Input()
  allowToggleButtons: boolean;

  @HostListener('input', ['$event.target.value'])
  // @HostListener('click', ['$event.target.value']) // This was triggering a detect chage lifecycle on every click, which is not ideal. And also the ngx-mask already does this.
  onChange = (_: any) => {};

  value: string | null = null;
  unit: 'abs' | 'pct' | null = null;

  private VALUE_REGEX = /-?\d+(\.\d+)?/g;
  private UNIT_REGEX = /[^0-9\-.]+/g;

  constructor(injector: Injector, private cd: ChangeDetectorRef) {
    super(injector);
    this.allowToggleButtons = true;
  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

  setUnit(type) {
    this.unit = type;
  }

  setValue(e) {
    this.value = e.target.value;
  }

  registerOnChange(fn: any): void {
    this.onChange = () => {
      const value = this.value ? this.value.replace(/,/g, '') : null;
      const unit = this.unit === 'pct' ? '%' : '';
      const output = value === null ? null : value + unit;
      fn(output);
    };
  }

  writeValue(inputString: string | null): void {
    if (inputString && typeof inputString === 'string') {
      this.value = this.parseValueFromString(inputString);
      this.unit = this.defaultUnit ?? this.parseUnitFromString(inputString);
    } else {
      this.value = null;
      this.unit = this.defaultUnit;
    }
  }

  parseValueFromString(value: string): string {
    const numbers = value?.match(this.VALUE_REGEX) || [];
    return numbers.length ? numbers.join() : '';
  }

  parseUnitFromString(value: string): 'pct' | 'abs' {
    const letters = value?.match(this.UNIT_REGEX) || [];
    const unit = letters.join();
    const out = unit.includes('%') ? 'pct' : 'abs';
    return out;
  }

  toggleValues(): void {
    if (this.allowToggleButtons) {
      this.unit = this.unit === 'pct' ? 'abs' : 'pct';
      this.convertValues();
    }
  }

  convertValues(): void {
    if (this.value === null || this.value === '') {
      return;
    } else {
      const valueAsNumber = parseFloat(this.value?.replace(/,/g, ''));

      let convertedValue =
        this.unit === 'pct' ? valueAsNumber * 100 : valueAsNumber / 100;

      convertedValue = parseFloat(convertedValue.toFixed(4));

      const convertedValueAsString = `${convertedValue}${
        this.unit === 'pct' ? '%' : ''
      }`;
      this.control.setValue(convertedValueAsString);
      this.writeValue(convertedValueAsString);
    }
  }

  getValidationStatus(): string {
    return this.control.invalid
      ? 'invalid'
      : this.showTicksIfValid
      ? 'valid'
      : '';
  }
}
